import { render, staticRenderFns } from "./SimpleNote.vue?vue&type=template&id=a9800762"
import script from "./SimpleNote.vue?vue&type=script&lang=js"
export * from "./SimpleNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports